import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';

@Component({
  selector: 'product-page-display-conditions-tab',
  templateUrl: './product-page-display-conditions-tab.component.html',
  styleUrls: ['./product-page-display-conditions-tab.component.scss'],
  standalone: false,
})
export class ProductPageDisplayConditionsTabComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() shop: Shop;
}
